import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Ana Martínez',
  role: 'Docente de Secundaria',
  location: 'Madrid',
  text: 'Increíble el tiempo que me ahorro. Las planificaciones están perfectas y a los chicos les encantan los mapas visuales. Recuperé mis fines de semana.',
  rating: 5
}, {
  name: 'Carlos Ruiz',
  role: 'Profesor de Geografía',
  location: 'Buenos Aires',
  text: 'El material es súper completo. Lo que más valoro es la estructura de los 6 libros, cubre todo el programa anual sin dejar nada afuera. Muy recomendado.',
  rating: 5
}, {
  name: 'Laura Gómez',
  role: 'Profesora Nivel Medio',
  location: 'México DF',
  text: 'Al principio dudé por ser digital, pero la calidad es excelente. Los bonos de mapas son un plus gigante para mis clases. Mis alumnos participan mucho más.',
  rating: 5
}, {
  name: 'Roberto Paez',
  role: 'Docente',
  location: 'Santiago',
  text: 'Es justo lo que necesitaba. Basta de improvisar clases. Ahora entro al aula segura y con material de calidad. La guía de primeros auxilios fue una sorpresa muy útil.',
  rating: 5
}, {
  name: 'Sofía López',
  role: 'Profesora de Ciencias Sociales',
  location: 'Bogotá',
  text: 'La mejor inversión del año escolar. El precio es un regalo para la cantidad de material que trae. Ya lo estoy usando con mis cursos de 2do y 3ro.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-16 bg-white" data-id="element-26">
      <div className="max-w-6xl mx-auto px-4" data-id="element-27">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-28">
          ⭐ Lo que dicen los docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-30">
              <div className="flex gap-1 mb-4" data-id="element-31">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-blue-500 text-blue-500" data-id="element-32" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-33">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-34">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold" data-id="element-35">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-36">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-37">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-38">
                    {t.role} • {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}